/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Rodzaj wpisu w historii planu: zmiana statusu cyklu albo zmiana kroku.
 * @export
 * @enum {string}
 */

export const DevelopmentPathChangeTypeDto = {
    CycleStateChange: 'CYCLE_STATE_CHANGE',
    StepAdded: 'STEP_ADDED',
    StepUpdated: 'STEP_UPDATED',
    StepDeleted: 'STEP_DELETED',
    StepMarkedDone: 'STEP_MARKED_DONE',
    StepMarkedUndone: 'STEP_MARKED_UNDONE'
} as const;

export type DevelopmentPathChangeTypeDto = typeof DevelopmentPathChangeTypeDto[keyof typeof DevelopmentPathChangeTypeDto];



